import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #000000;
  padding: 24px 16px;

  p {
    color: #ccc;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.5px;
    margin: 0;
    text-align: center;
  }

  h1,
  h2 {
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 24px;
    font-style: normal;
    font-weight: 350;
    line-height: 32px; /* 133.333% */
    color: #fff;
    text-align: center;
    margin: 0;
  }
  h3 {
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    color: #fff;
  }
  strong {
    font-family: "Mark For MC Narrow W00 Bold";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 16px;
  width: 100%;
  align-self: stretch;
  border-radius: 6px;
  background-color: #282827;
  .wearable-container {
    width: 100%;
    width: auto;
    height: 342px;
    margin: 0 auto;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .balance-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    padding: 16px 8px;
    .balance-value {
      font-size: 28px;
      font-style: normal;
    }
  }
  .how-it-works {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    padding-bottom: 40px;
  }
  .priceless-link {
    margin-top: 16px;
    width: 220px;
    height: 40px;
    background-color: #fd661b;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 16px;
    color: white;
    text-decoration: none;
    text-align: center;
    line-height: 24px;
    letter-spacing: 0.5px;
    font-weight: 700;
    text-decoration: none;
    text-align: center;
  }
  .priceless-link-container {
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
  }
`;

export const IntroSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 40px 16px;
  width: 100%;
  align-self: stretch;
  background-color: #282827;
  .intro-logo {
    width: 250px;
    height: 53px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0px 48px;
  width: 100%;
  align-self: stretch;
  background-color: #282827;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
  gap: 8px;
  img {
    height: 33px;
  }

  .powered-by {
    color: #fff;
    font-family: "Inter";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
  }

  .links-text {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }
`;
